import { H4 } from "@/components/ui/typography";
import OLTEvidenceHandler from "./opm-evidence/OLTEvidenceHandler";
import FeederEvidenceHandler from "./opm-evidence/FeederEvidenceHandler";
import ActivityEvidenceHandler from "./opm-evidence/ActivityEvidenceHandler";
import ClampHookEvidenceHandler from "./opm-evidence/ClampHookEvidenceHandler";
import { useParams } from "react-router-dom";
import { MISSING_ID_IN_ROUTE } from "@/utils/constant";
import { useOpmEvidences } from "@/api/opm-evidence";

export default function OPMEvidence() {
  const { id } = useParams();
  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }

  const { data: evidences } = useOpmEvidences({ rfsId: id });

  const oltEvidence = evidences?.find(
    (evidence) => evidence.opmEvidenceType === "olt",
  );
  const feederEvidence = evidences?.find(
    (evidence) => evidence.opmEvidenceType === "feeder",
  );
  const activityEvidence = evidences?.find(
    (evidence) => evidence.opmEvidenceType === "activity",
  );
  const clampHookEvidence = evidences?.find(
    (evidence) => evidence.opmEvidenceType === "clamphook",
  );
  return (
    <div className="!mt-8 space-y-4">
      <H4>OPM Evidence</H4>
      <span className="text-sm text-slate-500">
        OPM Evidence only accepts .zip upload files containing photos and must
        have metadata
      </span>

      <div className="x grid grid-cols-1 gap-4">
        <OLTEvidenceHandler oltEvidence={oltEvidence} />
        <FeederEvidenceHandler feederEvidence={feederEvidence} />
        <ActivityEvidenceHandler activityEvidence={activityEvidence} />
        <ClampHookEvidenceHandler clampHookEvidence={clampHookEvidence} />
      </div>
    </div>
  );
}
